import { binCountSessionIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const cancelBinCountSession = {
  name: "cancelBinCountSession" as const,
  input: z.object({ binCountSessionId: binCountSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
